import { render } from "./ParentManagement.vue?vue&type=template&id=79f63286"
import script from "./ParentManagement.vue?vue&type=script&lang=js"
export * from "./ParentManagement.vue?vue&type=script&lang=js"

import "./ParentManagement.vue?vue&type=style&index=0&id=79f63286&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__